'use strict';

/**
 * @class VZComment
 * @example <textarea is="vz-comment" max-length-threshold="50" max-length-warning-plural="remaining characters" max-length-warning-singular="remaining character" max-length="500"></textarea>
 */
class VZComment extends HTMLTextAreaElement {
    constructor() {
        super();

        this.threshold = this.getAttribute('max-length-threshold');
        this.maxLengthWarningPlural = this.getAttribute('max-length-warning-plural');
        this.maxLengthWarningSingular = this.getAttribute('max-length-warning-singular');
    }

    onInput() {
        if (this.maxLength - this.value.length <= this.threshold) {
            this.showWarning(this.maxLength - this.value.length);
        } else {
            this.removeWarning();
        }
    }

    removeWarning() {
        if (this.nextElementSibling.classList.contains('warning')) {
            this.nextElementSibling.remove();
        }
    }

    showWarning(remaining) {
        const nextElement = this.nextElementSibling;
        if (nextElement.classList.contains('warning')) {
            nextElement.querySelector('b').innerText = remaining;
        } else {
            this.insertAdjacentHTML(
                'afterend',
                `
                <div class="text-end text-primary py-1 warning">
                    <i class="icon icon-warning" aria-hidden="true"></i>
                    <small><b>${remaining}</b> ${remaining === 1 ? this.maxLengthWarningSingular : this.maxLengthWarningPlural}</small>
                </div>
            `
            );
        }
    }

    connectedCallback() {
        if (this.maxLength && this.getAttribute('max-length-threshold') && this.getAttribute('max-length-warning-plural') && this.getAttribute('max-length-warning-singular')) {
            this.addEventListener('input', this.onInput);
        }
    }
}

export default VZComment;

customElements.define('vz-comment', VZComment, { extends: 'textarea' });
